import { Grid, InputLabel, MenuItem, OutlinedInput, Select } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { useCadastrosBasicoState } from "../context/cadastros-basico-context";
import { FORM_TYPES } from "../context/cadastros-basico-reducer";
import { useCadastrosBasicoController } from "../context/cadastros-basico-controller";

export const LinkServicosForm = () => {
    const { dataRequest } = useCadastrosBasicoState();
    const { handleOnChangeForm } = useCadastrosBasicoController();

    const firstInputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (firstInputRef.current) {
            firstInputRef.current.focus();
        }
    }, []);
    
    return (
        <React.Fragment>
            <Grid container spacing={2}>
                <Grid
                    item
                    lg={12}
                    sm={12}
                    xl={12}
                >
                    <InputLabel>Titulo</InputLabel>
                    <OutlinedInput
                         ref={firstInputRef}
                        size="small"
                        inputProps={{ min: 0 }}
                        error={dataRequest?.title === undefined || dataRequest?.title.length === 0 ? true : false}
                        name="input-title"
                        value={dataRequest?.title}
                        defaultValue={dataRequest?.title}
                        onChange={(e) => handleOnChangeForm(FORM_TYPES.linkServices, e)}
                        fullWidth
                    />
                </Grid>
                <Grid
                    item
                    lg={12}
                    sm={12}
                    xl={12}
                >
                    <InputLabel>Subtitulo</InputLabel>
                    <OutlinedInput
                        size="small"

                        error={dataRequest?.subtitle === undefined || dataRequest?.subtitle.length === 0 ? true : false}

                        inputProps={{ min: 0 }}
                        name="input-subtitle"
                        value={dataRequest?.subtitle}
                        defaultValue={dataRequest?.subtitle}
                        onChange={(e) => handleOnChangeForm(FORM_TYPES.linkServices, e)}
                        fullWidth
                    />
                </Grid>
                <Grid
                    item
                    lg={12}
                    sm={12}
                    xl={12}
                >
                    <InputLabel>Url (http)</InputLabel>
                    <OutlinedInput
                        size="small"
                        inputProps={{ min: 0 }}
                        name="input-url"
                        error={dataRequest?.url === undefined || dataRequest?.url.length === 0 ? true : false}

                        value={dataRequest?.url}
                        defaultValue={dataRequest?.url}
                        onChange={(e) => handleOnChangeForm(FORM_TYPES.linkServices, e)}
                        fullWidth

                    />
                </Grid>
                <Grid item lg={6}
                    sm={6}
                    xl={6}>
                    <InputLabel>Icone</InputLabel>
                    <Select
                        size="small"
                        name='select-icon'
                        error={dataRequest?.icon === undefined || dataRequest?.icon === undefined ? true : false}

                        value={dataRequest?.icon}
                        defaultValue={dataRequest?.icon}
                        onChange={(e) => handleOnChangeForm(FORM_TYPES.linkServices, e)}
                        fullWidth
                    >
                        <MenuItem value={undefined} key={0}>
                            <em>Selecionar</em>
                        </MenuItem>
                        <MenuItem value={1} key={1}>
                            Documento
                        </MenuItem>
                        <MenuItem value={2} key={2}>
                            Telefone
                        </MenuItem>
                        <MenuItem value={3} key={3}>
                            Nota de Dinheiro
                        </MenuItem>
                        <MenuItem value={4} key={4}>
                            Bulb
                        </MenuItem>
                        <MenuItem value={5} key={5}>
                            Pessoa
                        </MenuItem>

                        <MenuItem value={6} key={6}>
                            Casa
                        </MenuItem>
                        <MenuItem value={7} key={7}>
                            Folha de Papel
                        </MenuItem>

                    </Select>
                </Grid>

            </Grid>
        </React.Fragment>
    );
}